export default "__VITE_ASSET__DFprATUB__"